var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNortalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-4 -30.6 601.6 315.6",
    style: {
      enableBackground: "new -4 -30.6 601.6 315.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.3,87.3 237.9,87.3 269.8,138.4 269.8,87.3 285.5,87.3 285.5,165.3 271.1,165.3 239.1,114.6  239.1,165.3 223.3,165.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,167.1c-9.1,0-16.2-2.6-21.2-7.9c-5-5.2-7.5-12.7-7.5-22.5c0-4.7,0.7-8.9,2-12.6 c1.3-3.7,3.3-6.9,5.8-9.5c2.5-2.6,5.5-4.6,9.1-6c3.5-1.4,7.5-2.1,11.8-2.1c4.4,0,8.4,0.7,11.9,2.1c3.5,1.4,6.6,3.4,9.1,6 c2.5,2.6,4.4,5.8,5.7,9.5c1.3,3.7,2,8,2,12.6c0,4.7-0.7,9-2,12.7c-1.3,3.8-3.3,6.9-5.8,9.6c-2.5,2.6-5.5,4.6-9.1,6 C329.6,166.4,325.7,167.1,321.3,167.1 M321.3,154.8c4.3,0,7.6-1.6,9.7-4.7c2.1-3.1,3.2-7.6,3.2-13.4c0-5.8-1.1-10.3-3.2-13.3 c-2.1-3.1-5.4-4.6-9.7-4.6s-7.6,1.5-9.7,4.6c-2.1,3.1-3.2,7.5-3.2,13.3c0,5.9,1,10.4,3.2,13.5 C313.7,153.3,316.9,154.8,321.3,154.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.3,107.8h14.8v9.4c3.6-9.7,18.6-9.5,19.3-9.4v12.8c-1.2,0-4.9-0.5-9.5,0.9c-4.6,1.4-9.4,4.5-9.4,10.8v33 h-15.2L357.3,107.8L357.3,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,120.7h-10.4l0-12.8h10.4V92.7h15.2v15.2h13v12.8h-13v25.4c0,3,0.6,5,1.8,6.1c1.2,1.1,2.8,1.6,4.8,1.6 c1,0,2-0.1,3.1-0.2c1-0.1,2.1-0.3,3.1-0.6l3.2,10.9c-2.1,0.7-5.2,1.5-7.2,1.7c-2,0.3-3.9,0.4-5.7,0.4c-6.2,0-10.8-1.5-13.8-4.5 c-3-3-4.5-8-4.5-15.1L406.6,120.7L406.6,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479.5,158.1c-2.2,2.6-4.8,4.6-7.5,6.2c-2.8,1.6-6.4,2.4-10.8,2.4c-2.5,0-4.9-0.3-7.2-1 c-2.3-0.7-4.3-1.7-6-3.1c-1.7-1.4-3.1-3.2-4.1-5.3c-1-2.1-1.5-4.7-1.5-7.7c0-3.9,0.9-7.1,2.6-9.6c1.7-2.5,4-4.4,6.8-5.8 c2.8-1.4,6-2.4,9.5-2.9c3.5-0.6,7.1-0.9,10.7-1.1l7.3-0.3v-2.8c0-3.5-1-5.9-2.9-7.2s-4.2-2-6.8-2c-6,0-9.4,2.3-10.3,6.9l-13.9-1.3 c1-6,3.6-10.3,7.8-12.9c4.2-2.7,9.8-4,16.9-4c4.3,0,8,0.5,11.1,1.6c3,1.1,5.5,2.6,7.3,4.5c1.8,2,3.2,4.4,4,7.2 c0.8,2.8,1.2,5.9,1.2,9.4v36h-14.3V158.1z M479.1,139.9l-6.7,0.3c-3.2,0.1-5.8,0.5-7.7,1c-2,0.5-3.5,1.1-4.5,1.9 c-1,0.8-1.8,1.7-2.1,2.7c-0.4,1-0.5,2.1-0.5,3.4c0,1.9,0.6,3.4,2,4.5c1.3,1.1,3.1,1.6,5.4,1.6c3.9,0,7.1-0.9,9.6-2.7 c1.4-1,2.5-2.3,3.4-3.9s1.3-3.5,1.3-5.8L479.1,139.9L479.1,139.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.7,
    y: 87.3,
    className: "st0",
    width: 15.2,
    height: 78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,197.6c-1.8,0-3.2-1.7-3.2-3.9V60.6c0-2.1,1.5-3.9,3.2-3.9c1.8,0,3.2,1.7,3.2,3.9v133.1 C82.2,195.9,80.8,197.6,79,197.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,205.3c-1.8,0-3.2-1.7-3.2-3.9V53c0-2.1,1.5-3.9,3.2-3.9c1.8,0,3.2,1.7,3.2,3.9v148.4 C95.2,203.5,93.8,205.3,92,205.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105,197.6c-1.8,0-3.2-1.7-3.2-3.9V60.6c0-2.1,1.5-3.9,3.2-3.9s3.2,1.7,3.2,3.9v133.1 C108.2,195.9,106.8,197.6,105,197.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157,197.6c-1.8,0-3.2-1.7-3.2-3.9V60.6c0-2.1,1.5-3.9,3.2-3.9c1.8,0,3.2,1.7,3.2,3.9v133.1 C160.3,195.9,158.8,197.6,157,197.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,205.3c-1.8,0-3.2-1.7-3.2-3.9V53c0-2.1,1.5-3.9,3.2-3.9s3.2,1.7,3.2,3.9v148.4 C173.3,203.5,171.8,205.3,170,205.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183,197.6c-1.8,0-3.2-1.7-3.2-3.9V60.6c0-2.1,1.5-3.9,3.2-3.9c1.8,0,3.2,1.7,3.2,3.9v133.1 C186.3,195.9,184.8,197.6,183,197.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118,151.8c-1.8,0-3.2-1.7-3.2-3.9v-72c0-2.1,1.5-3.9,3.2-3.9c1.8,0,3.2,1.7,3.2,3.9v72 C121.2,150,119.8,151.8,118,151.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131,167.1c-1.8,0-3.2-1.7-3.2-3.9v-72c0-2.1,1.5-3.9,3.2-3.9s3.2,1.7,3.2,3.9v72 C134.2,165.3,132.8,167.1,131,167.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,182.3c-1.8,0-3.2-1.7-3.2-3.9v-72c0-2.1,1.5-3.9,3.2-3.9s3.2,1.7,3.2,3.9v72 C147.2,180.6,145.8,182.3,144,182.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNortalLogo);
export default __webpack_public_path__ + "static/media/NortalLogo.874ffe22801aaa51ae435d97f2324102.svg";
export { ForwardRef as ReactComponent };